// extracted by mini-css-extract-plugin
export default {"dropdown":"SearchContainer_dropdown__CERwe","no_result":"SearchContainer_no_result__-XC9H"};